import { render, staticRenderFns } from "./string-editor.vue?vue&type=template&id=9639f152&"
import script from "./string-editor.vue?vue&type=script&lang=ts&"
export * from "./string-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9639f152')) {
      api.createRecord('9639f152', component.options)
    } else {
      api.reload('9639f152', component.options)
    }
    module.hot.accept("./string-editor.vue?vue&type=template&id=9639f152&", function () {
      api.rerender('9639f152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/string-editor.vue"
export default component.exports